module.exports = __webpack_public_path__ + "img/icon-login.a46d0700.svg";